<template>
<!-- 视力报告-列表页面 -->
    <div class="class_page">
        <div class="content">
            <div class="school_top">
                <!-- 年级 班级 下拉 -->
                <div class="select_box">
                    <div class="select">
                        <p class="grade">{{ gradeId }}</p>
                        <ul v-show="showOptions">
                            <li v-for="item in gradeList" :key="item.index" @click.stop="choose(item.value)"><a href="javascript:;">{{item.value}}</a></li>
                        </ul>
                    </div>
                    <div>
                        <p class="grade class" @click.stop="funshowClassOptions">{{ classId }}</p>
                        <ul v-show="showClassOptions">
                            <li v-for="item in classList" :key="item.index" @click.stop="chooseClass(item.value)"><a href="javascript:;">{{item.value}}</a></li>
                        </ul>
                    </div>
                </div>

                <!-- 分割线 -->
                <div class="dividing_line">|</div>

                <!-- 时间+日历 -->
                <div class="select_time">
                    <span class="time">{{time}}</span>
                    <span class="calendar_icon"><img @click="fun_calendar" src="../../assets/icon-calendar@2x.png"></span>
                </div>
                <div class="select_time time_end">
                    <!-- 结束时间 -->
                    <span class="time" style="margin-left: 10px">{{timeEnd}}</span>
                    <span class="calendar_icon"><img @click="funTimeEnd" src="../../assets/icon-calendar@2x.png"></span>
                </div>
            </div>

            <div class="result_title">
                <span>设备使用人数：{{number_result}}</span>
                <span>设备使用率：{{rate_result}}%</span>
            </div>

            <div class="list_container">
                <div class="list_Header">
                    <van-row type="flex" justify="center" align="center">
                        <van-col span="4">姓名</van-col>
                        <van-col span="4">学籍号</van-col>
                        <van-col span="4">设备号</van-col>
                        <van-col span="4">手机号</van-col>
                        <van-col span="4">次数</van-col>
                        <van-col span="4">详情</van-col>
                    </van-row>
                </div>
                <div class="list_content">
                    <van-row class="row" v-for="item in listmap" :key="item.index" type="flex" justify="center" align="center">
                        <van-col class="col" span="4">{{item.sname}}</van-col>
                        <van-col class="col" span="4">{{item.statusid}}</van-col>
                        <van-col class="col" span="4">{{item.instrumentid == 0 ? '无' : item.instrumentid}}</van-col>
                        <van-col class="col" span="4">{{item.sphone == 0 ? '无' : item.sphone}}</van-col>
                        <van-col class="col" span="4">{{item.stuNumber}}</van-col>
                        <van-col class="col no-right" span="4" @click="funSee(item.statusid, item.sname)">查看</van-col>
                    </van-row>
                </div>
            </div>
        </div>
        <!-- 日历弹出 -->
        <van-popup v-model="show" :style="{ height: '40%' }">
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="timeSave"
            @cancel="onCancel"
            />
        </van-popup>

        <van-popup v-model="showTimeEnd" :style="{ height: '40%' }">
            <!-- 结束时间 -->
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minTimeEnd"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="timeFunEnd"
            @cancel="onCancel"
            />
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import { Circle } from 'vant';
import { Row, Col } from 'vant';

Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Circle);
Vue.use(Row).use(Col);
export default {
    props: {

    },
    data() {
        return {
            showOptions: false, // 年级
            showClassOptions: false,    //班级
            show: false,    //选择时间
            showTimeEnd: false,     // 选择结束时间

            currentDate: new Date(),
            minDate: new Date(1900,0,1),
            minTimeEnd: new Date(1900,0,1),

            maxDate: new Date(),
            // 选择年级
            gradeId: '',
            gradeList: [
                {
                    key: -1, value: "年级"
                },
                {
                    key: 1, value: "一年级"
                },
                {
                    key: 2, value: "二年级"
                },
                {
                    key: 3, value: "三年级"
                },
                {
                    key: 4, value: "四年级"
                },
                {
                    key: 5, value: "五年级"
                },
                {
                    key: 6, value: "六年级"
                }
            ],
            // 选择班级
            classId: '',
            classList: [
                {
                    key: -1, value: "班级"
                },
                {
                    key: 1, value: "一班"
                },
                {
                    key: 2, value: "二班"
                },
                {
                    key: 3, value: "三班"
                }
            ],
            time: '',   // 显示时间
            timeEnd: '',

            gradeTitle: '各年级',
            classTitle: '',

            number_result: 0,      // 设备使用人数
            rate_result: 0,     // 设备使用率
            classtatol: 0,  // 班级总人数
            gradeName: 0,

            listmap: [],
        };
    },
    computed: {

    },
    created() {
        // this.gradeName =
        this.classId = this.$route.params.className
        this.gradeList.map(item=>{
            if(this.$route.params.gradeName == item.key) {
                this.gradeId = item.value
            }
        })
        this.time = this.$route.params.ft
        this.timeEnd = this.$route.params.et

        this.classList = this.$route.params.classList

        this.get(this.$route.params.gradeName,this.$route.params.ft,this.$route.params.et,this.$route.params.className)

    },
    mounted() {
        let that = this
        document.addEventListener('click', function() {
            that.showOptions = false
            that.showClassOptions = false
        })
    },
    watch: {

    },
    methods: {
        // 获取数据
        get(gN,t,et,cN) {
            this.axios.get('/weixin/student/getClasss', {
                params: {
                    gradeName: gN,
                    ft: t,
                    et: et,
                    className: cN
                }
            })
            .then(res=>{
                let data = res.data
                this.listmap = data.listmap
                this.classtatol = this.listmap.length
                let i = 0
                this.listmap.filter(item=>{
                    if(item.stuNumber != 0) {
                        i++
                    }
                })
                this.number_result = i
                this.rate_result = Math.round( (this.number_result / this.classtatol) * 100)
            })
        },

        funshowClassOptions() {
            this.showClassOptions = !this.showClassOptions
            this.showOptions = false
        },
        // 选择班级
        chooseClass(value) {
            this.showOptions = false
            this.showClassOptions = false
            if (value !== this.classId) {
                this.classId = value
            }

            if(value!='班级') { // 如果选择了班级
                this.classTitle = value
            }else {
                this.classTitle = ''
            }

            this.get(this.$route.params.gradeName,this.time,this.timeEnd,value)
        },

        // 日历
        fun_calendar() {
            this.show = true;
        },

        // 修改时间格式
        formatter(type, value) {
            if (type === 'year') {
                return `${value}年`;
            } else if (type === 'month') {
                return `${value}月`
            } else if(type === 'day') {
               return `${value}日`
            }
            return value;
        },

        // 确认修改开始时间
        timeSave(val) {
            this.time = val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate()
            this.show = false;
            this.minTimeEnd = new Date(this.time)
        },

        funTimeEnd() {
            this.showTimeEnd = true;
        },
        // 确认修改结束时间
        timeFunEnd(val) {
            this.timeEnd = val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate()
            this.showTimeEnd = false;
            this.get(this.$route.params.gradeName,this.time,this.timeEnd,this.classId)
        },

        // 取消
        onCancel () {
            this.show = false;
        },

        // 点击查看
        funSee(statusid,sname) {
            this.$router.push({
                name: 'StudentDetails',
                params: {
                    gradeName: this.$route.params.gradeName,
                    ft: this.time,
                    et: this.timeEnd,
                    className: this.classId,
                    statusid: statusid,
                }
            })
        }

    },
    components: {

    },
};
</script>
<style>
.van-col--4 {
    white-space: nowrap;
    overflow: hidden;
    overflow-x: scroll;
    /* border-left: none; */
    /* border-right: none; */
}

.van-circle__text {
    font-size: 34px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>
<style scoped>
.class_page {
    padding: 30px;
}
.content {
    background: #fff;
    border-radius: 20px;
    padding-top: 36px;
}

.school_top {
    margin: 0 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
}
.select_box {
    display: flex;
}
.select {
    margin-right: 24px;
}
.select_time {
    display: flex;
    line-height: 54px;
}

.select_time img {
    margin-left: 10px;
    vertical-align: -4px;
}
.time {
    font-size: 30px;
}
.time_end {
    position: absolute;
    right: 0;
    top: 60px;
}
.grade {
    width: 166px;
    height: 54px;
    line-height: 54px;
    font-size: 36px;
    text-indent: 12px;
    color: #3f8ed4;
    border: 2px solid #3f8ed4;
    border-radius: 30px;
    background: url("../../assets/blue_select.png") no-repeat scroll right center transparent;
    background-position-x: 130px;
    background-size: 24px;
    letter-spacing: 0;
}
.class {
    width: 194px;
    background-position-x: 156px;
}
ul {
    position: absolute;
    z-index: 1008;
    background: #fff;
    width: 166px;
    margin-top: 10px;
    border: 2px solid #3f8ed4;
    border-radius: 10px;
    font-size: 36px;
}

li {
    height: 70px;
}

li a{
    height: 70px;
    line-height: 70px;
    width: 100%;
    display: inline-block;
    color: #3f8ed4;
    text-indent: 12px;
}

li a:hover,a:active {
    background: #3f8ed4;
    color: #fff;
}

.dividing_line {
    line-height: 54px;
    color: #e6e6e6;
    display: inline-block;
    padding-left: 10px;
}

.calendar_icon img{
    width: 50px;
}

.result_title {
    margin: 0 20px;
    margin-top: 80px;
    display: flex;
    font-size: 36px;
    justify-content: space-between;
}

.list_container {
    text-align: center;
}

.list_Header {
    margin-top: 30px;
    background: #3f8ed4;
    color: #fff;
    height: 70px;
    line-height: 70px;
    font-size: 34px;
}

.list_content {
    font-size: 34px;
}

.col {
    height: 70px;
    line-height: 70px;
    border-right: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
}

.no-right {
    border-right: none;
    color: #3f8ed4;
}
</style>



// WEBPACK FOOTER //
// src/views/second/ListOfReports.vue